<template>
  <div>
    <h4 class="title">Оформление профиля</h4>
    <span
      class="description"
    >Последний шаг! Загрузи картинку и свой аватар. Профиль в приложении станет круто выглядеть</span>
    <DropzoneProfile :contacts="contacts" @unbind="unbind" @bind="bind"></DropzoneProfile>
    <div class="btn-wrap">
      <router-link to="/profile/step/2/" class="btn btn-outline-primary">Назад</router-link>
      <span class="btn btn-primary" @click="save">Готово</span>
    </div>
  </div>
</template>

<script>
import DropzoneProfile from "@/components/profile/DropzoneProfile.vue";

export default {
  name: "Step3",
  components: {
   DropzoneProfile
  },
  props: ["contacts"],
  data() {
    return {
      
    };
  },
  methods: {
    save: function() {
      this.$emit('save');
    },
    unbind(type){
     this.$emit('unbind',type);
    },
    bind(type){
      this.$emit('bind',type);
    }
  }
};
</script>

<style lang="scss">
#layer {
  position: relative;
  z-index: 1;
  cursor: pointer;
  .picture_control {
    position: absolute;
    top: 16px;
    right: 16px;
  }
}

#avatar {
  cursor: pointer;
  position: relative;
  z-index: 2;
}
.drop-zone-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 56px;
  .picture_control {
    display: none;
  }
  .grounded {
    border: 1px solid $calmColor !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    cursor: default!important;
    .dz-message {
      .subtitle {
        display: none;
      }
      .picture_control {
        display: none;
        color: #fff;
        .change-pic,
        .remove-pic {
          width: 40px;
          height: 40px;
          flex: 0 0 40px;
          border-radius: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
        .change-pic {
          background: $mainColor;
          margin-right: 8px;
        }
        .remove-pic {
          background: #eb4b4b;
        }
      }
      &:hover {
        .picture_control {
          display: flex;
          z-index: 12;
        }
      }
    }
  }
  .dz-message {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .subtitle {
      text-align: center;
      color: $mainColor;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
    }
  }

  #layer {
    width: 100%;
    height: 247px;
    @include border();
    border-style: dashed;
  }
  #avatar {
    margin-top: -64px;
    width: 128px;
    height: 128px;
    @include border();
    border-radius: 128px !important;
    border-style: dashed;
    background: #fff;
  }
}
</style>